import { propsIndividual_obra } from "../../models/Colecciones.model";
import { base_url } from "../../constants";

export default function RowTabla(props: propsIndividual_obra) {
    
return(
  <div className="row mt-1">
  <div className="col-1">{props.n}</div>
    <div className="col-3"><a href={`/${base_url}/obras/${props.id}`} className="link_book_collection">{props.descripcion}</a></div>
    <div className="col-3">{props.autores}</div>
    <div className="col-2">c: {props.ISBNCompleta}<br/>d: {props.ISBNDigital}<br/>i: {props.ISBNImpresa}</div>
    <div className="col-3">{props.coleccion}</div>
    <hr/>
  </div>
)

}